import React from 'react';
import { graphql, useStaticQuery, Link as GatsbyLink } from 'gatsby';
import {
    Box,
    Link,
    Flex,
} from '@chakra-ui/react';
import styled from '@emotion/styled';
import TrecLogo from '../../Footer/Logos/TrecLogo';
import ChamberLogo from '../../Footer/Logos/ChamberLogo';
import TetonGeoCenterLogo from '../../Footer/Logos/TetonGeoCenterLogo';

const NavItem = styled(Box)`
    color: white;
    font-size: 1.5rem;
    text-transform: uppercase;
    font-weight: 800;
    padding-left: ${props => props.pl ? props.pl : '8'};
    padding-right: ${props => props.pr ? props.pr : '8'};
    > a:hover {
        color: #F3CB2A;
        text-decoration: none;
    }

    > a.active {
        color: #F3CB2A;
        text-decoration: none;
    }
    
`

const Navbar = (props) => {
    const data = useStaticQuery(graphql`
    {
        prismicNavigation {
          data {
            nav_items {
              nav_label
              nav_link {
                url
              }
            }
          }
        }
      }
  `)

  const document = data.prismicNavigation.data;
    return (
        <Flex w="100%" 
            bg="blue.500"
            p="4"
            justifyContent="space-between"
            display={{base: 'none', lg: 'flex'}}
            height="100px"
            alignItems="center"
            as="nav"
            h="6.5rem"
        >
            <Box w={{base: '100%', lg: '60%'}} >
                <Flex
                justifyContent="flex-start"
                px="4"
                >
                    {document.nav_items.map((item, index) => (
                        <NavItem key={index} pl={{base: 1, md: 4}} pr={{base: 1, md: 8}}>
                            <Link as={GatsbyLink} to={item.nav_link.url} activeClassName="active" variant="nav-item" partiallyActive={true}>
                                {item.nav_label}
                            </Link>
                        </NavItem>
                    ))}
                </Flex>
            </Box>
            <Box w={{base: '100%', lg: '40%'}} >
                <Flex w="100%"
                    justifyContent="flex-end"
                    px="4"
                >
                    <Box w="6.5rem" mx="4">
                        <TrecLogo width="100%" pageLocation={props.pageLocation}/>
                    </Box>
                    {/* <Box w="6rem" mx="4">
                        <ChamberLogo width="100%" pageLocation={props.pageLocation}/>
                    </Box>
                    <Box w="7rem" mx="4">
                        <TetonGeoCenterLogo width="100%" pageLocation={props.pageLocation} />
                    </Box> */}
                    {/* <NavItem href="/" pl={{base: 1, md: 4}} pr={{base: 1, md: 4}}>
                        <Link as={GatsbyLink} to="/trec" activeClassName="active" variant="nav-item">
                            TREC
                        </Link>
                    </NavItem>
                    <NavItem href="/" pl={{base: 1, md: 4}} pr={{base: 1, md: 4}}>
                        <Link as={GatsbyLink} to="/chamber-of-commerce" activeClassName="active" variant="nav-item">
                            Chamber
                        </Link>
                    </NavItem>
                    
                    <NavItem href="/" pl={{base: 1, md: 4}} pr={{base: 1, md: 4}}>
                        <Link as={GatsbyLink} to="/teton-geo-center" activeClassName="active" variant="nav-item">
                            GEO CENTER
                        </Link>
                    </NavItem> */}
                </Flex>
            </Box>
        </Flex>
    )
}

export default Navbar;